import { useRouteError } from "react-router-dom";

export default function ErrorPage() {
  const error = useRouteError();
  console.error(error);

  return (
    <div id="error-page">
      <h1>Oops!</h1>
      <p>
        Sorry, an unexpected error occurred with the routing of components...
      </p>
      <p>
        <i>{error.statusText || error.message}</i>
      </p>
      <p>
        <b>{error.data}</b>
      </p>
    </div>
  );
}
